export default __webpack_public_path__ + "static/media/affligem_background_xl1.023247d7.jpg";